import Table from "react-bootstrap/Table";

import { User } from "@/@types/sintegrada/User";
import { ResumeGrouped } from "@/services/esus/attendanceService";
import { timeToString } from "@/utils/dateUtil";

type Props = {
	aggregatedByProfessionalsAndRiskClassificationStatus: ResumeGrouped<
		User,
		ResumeGrouped<"Reclassificações" | "Classificações", object>
	>[];
	averageTimeInSecondsByProfessional: ResumeGrouped<User, object>[];
};

export default function AttendanceByProfessionalTable({
	aggregatedByProfessionalsAndRiskClassificationStatus,
	averageTimeInSecondsByProfessional,
}: Props) {
	return (
		<Table className="text-center" responsive striped bordered hover>
			<thead>
				<tr className="fw-bolder">
					<th className="ps-2 text-start">Profissional</th>
					<th>Classificações</th>
					<th>Reclassificações</th>
					<th className="pe-2">Tempo médio de atendimento</th>
				</tr>
			</thead>
			<tbody>
				{(aggregatedByProfessionalsAndRiskClassificationStatus || []).map(
					(aggregatedProfessional, index) => (
						<tr key={`attendances-by-professional-table-row-${index}`}>
							<td className="ps-2 text-start">{aggregatedProfessional.key.name}</td>
							<td>
								{(aggregatedProfessional.values || []).find(
									(classificatedAttendances) =>
										classificatedAttendances.key === "Classificações"
								)?.total || 0}
							</td>
							<td>
								{(aggregatedProfessional.values || []).find(
									(classificatedAttendances) =>
										classificatedAttendances.key === "Reclassificações"
								)?.total || 0}
							</td>
							<td className="pe-2">
								{timeToString(
									(averageTimeInSecondsByProfessional || []).find(
										(professionalGroup) =>
											professionalGroup.key.id ===
											aggregatedProfessional.key.id
									)?.total || 0
								)}
							</td>
						</tr>
					)
				)}
			</tbody>
		</Table>
	);
}
